import {init as initContentfulExtension} from 'contentful-ui-extensions-sdk';
import Vue from 'vue';
import {DatePicker, Select, Option} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css';

locale.use(lang);
Vue.use(DatePicker, {locale});
Vue.use(Select, {locale});
Vue.use(Option, {locale});

import App from './App.vue';
import store from './store';
import router from './router';

Vue.config.productionTip = false;

function initVue() {
  new Vue({
    store,
    router,
    render: h => h(App),
  }).$mount('#app');
}

// we're in an iframe setup, so initialize with the contentful SDK
if (window.parent !== window) {
  initContentfulExtension((extension) => {
    Vue.prototype.$extension = extension;
    initVue();
  });
}
else {
  initVue();
}
